import {
  compareDesc,
  format,
  toDate as toDateFns,
  isPast as isPastFns,
} from "date-fns";

export const DateObject = (
  date: Date | number | string = toDateFns(new Date())
) => {
  const replaceDateStringFormat = (date: string) => {
    return date.replace(/-/g, "/");
  };

  const baseFormat = (f: string = "dd-MM-yyyy") => {
    if (typeof date === "string") {
      return format(new Date(replaceDateStringFormat(date)), f);
    }
    return format(date, f);
  };

  const isPast = () => {
    if (typeof date === "string") {
      return isPastFns(new Date(replaceDateStringFormat(date)));
    }
    return isPastFns(date);
  };

  const dateTimeFormat = () => {
    const f = "dd-MM-yyyy, H:mm";
    if (typeof date === "string") {
      return format(new Date(replaceDateStringFormat(date)), f);
    }
    return format(date, f);
  };

  const userFormat = () => {
    const f = "dd-MM-yyyy";
    if (typeof date === "string") {
      return format(new Date(replaceDateStringFormat(date)), f);
    }
    return format(date, f);
  };

  const apiFormat = () => {
    const f = "MM-yyyy";
    if (typeof date === "string") {
      return format(new Date(replaceDateStringFormat(date)), f);
    }
    return format(date, f);
  };

  const isEqual = (comparedDate: Date) => {
    if (typeof date === "string") {
      return (
        compareDesc(new Date(replaceDateStringFormat(date)), comparedDate) === 0
      );
    }
    return compareDesc(date, comparedDate) === 0;
  };

  const getMonth = () => {
    return toDateFns(new Date(date)).getMonth();
  };

  const getFullYear = () => {
    if (typeof date === "string") {
      return toDateFns(new Date(replaceDateStringFormat(date))).getFullYear();
    }
    return toDateFns(new Date(date)).getFullYear();
  };

  const getDayOfMonth = () => {
    return toDateFns(new Date(date)).getDate();
  };

  const getTime = () => {
    const f = "H:mm";
    if (typeof date === "string") {
      return format(new Date(replaceDateStringFormat(date)), f);
    }
    return format(date, f);
  };

  const toDate = () => {
    if (typeof date === "string") {
      return new Date(replaceDateStringFormat(date));
    }
    return new Date(date);
  };

  const toNumber = () => {
    if (typeof date === "string") {
      return new Date(replaceDateStringFormat(date)).getTime();
    }
    return new Date(date).getTime();
  };

  return {
    userFormat,
    apiFormat,
    baseFormat,
    isEqual,
    toDate,
    getFullYear,
    getMonth,
    getDayOfMonth,
    getTime,
    toNumber,
    dateTimeFormat,
    isPast,
  };
};

export type DateObjectType = ReturnType<typeof DateObject>;
